// extracted by mini-css-extract-plugin
module.exports = {"photos":"Photos_photos__3VVrC","galleryContainer":"Photos_galleryContainer__3XISO"};